import { useMutation, useQuery } from 'react-query'

import { QueryKey } from '../../../common/api'
import { queryClient } from '../../../common/providers/query'
import { rolesApi } from '../api/role.api'
import { CreateRoleDto, UpdateRoleDto } from '../types/role.types'

export const useGetRoles = () => {
  return useQuery([QueryKey.Roles], async () => {
    const response = await rolesApi.getRoles()

    return response.data
  })
}

export const useRoleCreate = () => {
  return useMutation(
    (role: CreateRoleDto) => {
      return rolesApi.create(role)
    },
    {
      onSuccess: async () => {
        return Promise.all([queryClient.invalidateQueries(QueryKey.Roles)])
      },
    },
  )
}

export const useRoleUpdate = () => {
  return useMutation(
    (role: UpdateRoleDto) => {
      return rolesApi.update(role.id, role)
    },
    {
      onSuccess: async () => {
        return Promise.all([queryClient.invalidateQueries(QueryKey.Roles)])
      },
    },
  )
}

export const useRoleDelete = () => {
  return useMutation(
    async (roleId: number) => {
      await rolesApi.deleteRole(roleId)
    },
    {
      onSuccess: () => {
        return Promise.all([queryClient.invalidateQueries(QueryKey.Roles)])
      },
    },
  )
}
